module.exports = __webpack_public_path__ + "img/bupa_logo.ef6b8249.png";